import store from '@/store/index'

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}
export const validateIDFromBirthday = val => {
  const year = val.substring(1, 3)
  const month = val.substring(3, 5)
  const day = val.substring(5, 7)
  if (store.getters['admission/dataForm'] && store.getters['admission/dataForm']?.applicantForm?.birth_date) {
    const date = store.getters['admission/dataForm']?.applicantForm?.birth_date
    const splitDate = date.split('-')
    const birthYear = splitDate[0].substring(2, 4)
    const birthMonth = splitDate[1]
    const birthDay = splitDate[2]
    if (year === birthYear && month === birthMonth && day === birthDay) {
      return true
    }

    return false
  }
}
export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}
export const validateBirthdayFromID = val => {
  const birthdate = val
  const nationalID = store.getters['admission/dataForm']?.applicantForm?.national_id
  // Split the birthdate string into day, month, and year
  const [year, month, day] = birthdate.split('-')
  const miniYear = year.substring(2, 5)
  // Extract the year, month, and day from the national ID
  const yy = nationalID?.substring(1, 3)
  const mm = nationalID?.substring(3, 5)
  const dd = nationalID?.substring(5, 7)
  // Compare the extracted date with the provided birthdate
  if (!nationalID) return true
  return yy === miniYear && mm === month && dd === day
}
export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
export const validateSsn = val => {
  const re = /^(2|3)[0-9][1-9][0-1][1-9][0-3][1-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d$/
  return re.test(val)
}
// /^[A-Za-z ]*$/
export const englishOnly = val => {
  const re = /^[A-za-z][A-Za-z0-9_(@./#&+) ]*$/
  return re.test(val)
}
export const arabicOnly = val => {
  const re = /^[ا-يأ-ي][أ-ي0-9ءؤئ_(@./#&+) IVXivx]*$/
  // const re = /^[\u0621-\u064A ]+$/
  const result = re.test(val)
  return result
}

export const passportValidation = val => {
  const re = /^[a-zA-Z][1-9][0-9][0-9][0-9][0-9][0-9][0-9]$/
  const result = re.test(val)
  return result
}

export const codeValidation = val => {
  const re = /^[0-9-]+$/
  return re.test(val)
}

export const numberValidation = val => {
  const re = /[^0-9]/
  return !re.test(val)
}

export const validateCH = val => {
  const re = /^[1-9]$/
  return re.test(val)
}

export const addressValidation = val => {
  const re = /(?!^\d+$)^.+$/
  return re.test(val)
}

export const postCode = val => {
  const re = /^[0-9]{5}(-[0-9]{4})?$/
  const result = re.test(val)
  return result
}

export const mobileValidation = val => {
  const re = /^(\+201|01|00201)[0-2,5]{1}[0-9]{8}/
  const result = re.test(val)
  return result
}

export const ssnRequired = val => {
  const re = /[a-zA-Z0-9-,]+/
  const result = re.test(val)
  return result
}

export const fileValidation = val => {
  const re = /([a-zA-Z0-9\s_\\.\-:\\(\\)])+(.png|.jpg|.gif|.pdf)$/
  const result = re.test(val.name)
  return result
}

export const imagingFile = val => {
  const re = /([a-zA-Z0-9\s_\\.\-:\\(\\)])+(.png|.jpg)$/
  const result = re.test(val.name)
  return result
}
